import { render } from "./AddPodcastModal.vue?vue&type=template&id=4a1305a0"
import script from "./AddPodcastModal.vue?vue&type=script&lang=js"
export * from "./AddPodcastModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__